import { render } from "./UserBoard.vue?vue&type=template&id=7e94af2e&scoped=true"
import script from "./UserBoard.vue?vue&type=script&lang=js"
export * from "./UserBoard.vue?vue&type=script&lang=js"

import "./UserBoard.vue?vue&type=style&index=0&id=7e94af2e&scoped=true&lang=css"

import exportComponent from "/Users/yangyu/go/go-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e94af2e"]])

export default __exports__